document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document.querySelector('.banner-slider')?.classList.add('visible');
  }, 500); 

  // Usage
  const $sliderFor = $('.slider-for');
  const $sliderNav = $('.slider-nav');
  const $originalNavSlides = $sliderNav.find('.thumbnail-image');
  const $originalForSlides = $sliderFor.find('.slider-banner-image');

  const actualSlides = $originalNavSlides.length;
  const maxSlidesToShow = 7;
  const slidesToShow = Math.min(actualSlides, maxSlidesToShow);

  // Slick init: slider-for
  $sliderFor.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0067/8120/6599/files/left-arrow_1.png" alt="Previous"></button>',
    nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0067/8120/6599/files/arrow-right_1.png" alt="Next"></button>',
    arrows: true,
    infinite: true,
    fade: true,
    asNavFor: '.slider-nav',
    adaptiveHeight: true,
  });

  // Slick init: slider-nav
  $sliderNav.slick({
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToShow,
    vertical: true,
    arrows: false,
    asNavFor: '.slider-for',
    dots: false,
    adaptiveHeight: true,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
      { breakpoint: 1370, settings: { vertical: true, slidesToShow: Math.min(actualSlides, 7) }},
      { breakpoint: 1200, settings: { vertical: true, slidesToShow: Math.min(actualSlides, 7) }},
      { breakpoint: 992, settings: { vertical: false, slidesToShow: Math.min(actualSlides, 7) }},
      { breakpoint: 768, settings: { vertical: false, slidesToShow: Math.min(actualSlides, 6) }},
      { breakpoint: 500, settings: { vertical: false, slidesToShow: Math.min(actualSlides, 5) }},
      { breakpoint: 380, settings: { vertical: false, slidesToShow: Math.min(actualSlides, 4) }}
    ]
  });

  const productWrapper = document.querySelector('.thb-product-detail');
  const variantSelects = document.querySelector('variant-selects');

  if (productWrapper.dataset.updateMedia === 'true') {
    variantSelects.updateMedia();
  }
});